import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDOcRlUu8P29luZTSAsVWxgBB_6Yls5vVw",
  authDomain: "izzishowin.firebaseapp.com",
  projectId: "izzishowin",
  storageBucket: "izzishowin.firebasestorage.app",
  messagingSenderId: "117381934094",
  appId: "1:117381934094:web:846ed4b1adfe2348a3205f",
  measurementId: "G-B18LCK8V5C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;